module.exports = __webpack_public_path__ + "img/Woveon8.7952b08e.png";